import { Controller, useFormContext } from "react-hook-form";

import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";

import { communityConfigurationCardSx } from "./communityConfigurationStyles";

import type {
  CommunityConfigurationFormRentManagerSettings,
  CommunityConfigurationFormValues,
} from "./communitiesConfigurationForm";

const settings: Array<{
  description: string;
  field: keyof CommunityConfigurationFormRentManagerSettings;
  label: string;
}> = [
  {
    description:
      "Post a History Note on the Rent Manager tenant whenever the resident's BRL status changes (imported, moved out, coverage accepted or cancelled).",
    field: "liveNotesEnabled",
    label: "Write live History Notes",
  },
  {
    description:
      "Fill an empty Addendum Requirements Met By User Defined Field with Community Policy during the initial residents sync. The addendum date is not a User Defined Field; it comes from each community's default addendum date.",
    field: "shouldWriteDefaultUDFValues",
    label: "Write default UDF values",
  },
];

/**
 * Toggles for what Maple writes back to Rent Manager. Rendered only for
 * portfolios integrated with Rent Manager.
 */
export function RentManagerSettingsSection() {
  const { control } = useFormContext<CommunityConfigurationFormValues>();

  return (
    <Stack sx={communityConfigurationCardSx} spacing={2}>
      <Typography variant="h4">Rent Manager write-back</Typography>
      <Typography color="text.secondary">
        Choose which resident data Maple writes back to Rent Manager.
      </Typography>
      {settings.map(({ description, field, label }) => (
        <Controller
          control={control}
          key={field}
          name={`rentManagerSettings.${field}`}
          render={({ field: { onChange, value } }) => (
            <Stack spacing={0.5}>
              <FormControlLabel
                control={
                  <Switch
                    checked={Boolean(value)}
                    data-testid={`rent-manager-settings-${field}`}
                    inputProps={{ "aria-describedby": `${field}-description` }}
                    onChange={(_, checked) => onChange(checked)}
                  />
                }
                label={label}
              />
              <Typography
                color="text.secondary"
                id={`${field}-description`}
                variant="caption">
                {description}
              </Typography>
            </Stack>
          )}
        />
      ))}
    </Stack>
  );
}
